import styled from "styled-components";
import { BASIC_DARK_GRAY, BASIC_ORANGE } from "../../../constants/colors";
import { Button } from "../../atoms/Button";

type Props = {
  pickupDateText: string;
  onClickChangeButton: () => void;
};

export const PickUpDetail: React.FC<Props> = ({
  pickupDateText,
  onClickChangeButton,
}) => {
  return (
    <PickupDateTextContainer>
      <PickUpDateTextContainer>
        <Text>
          お受け取り日時
          <PickUpDateText>{pickupDateText}</PickUpDateText>
        </Text>
        <ButtonContainer>
          <Button
            btnStyle="secondary"
            text="時間変更"
            onClick={onClickChangeButton}
            size="xxs"
          />
        </ButtonContainer>
      </PickUpDateTextContainer>
      <DeliveryAttentionText>
        ※ご注文確定のお時間によっては、お受け取り日時がご選択いただいたお時間より変更となってしまう場合がございます。
      </DeliveryAttentionText>
    </PickupDateTextContainer>
  );
};

const PickupDateTextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  text-align: left;
  flex-direction: column;
`;

const DeliveryAttentionText = styled.p`
  text-align: left;
  margin: 0;
  padding: 5px 0;
  font-weight: 300;
  font-size: 14px;
  color: ${BASIC_ORANGE};
`;

const Text = styled.p`
  font-size: 14px;
  font-weight: 600;
`;

const PickUpDateTextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`;

const PickUpDateText = styled.span`
  margin-left: 10px;
  font-size: 16px;
`;

const ButtonContainer = styled.div`
  button {
    padding: 9px 12px;
    margin-left: 32px
    letter-spacing: 0;
    width: auto;
    font-size: 12px;
    line-height: 1em;
    color: ${BASIC_DARK_GRAY};
    font-weight: 300;
  }
`;
